export default __webpack_public_path__ + "static/media/wafer-bg-top-flat.668b2607.png";